import {Component, Input} from '@angular/core';
import {MenuItemType} from '@models/sidebar/menu-item-type';

@Component({
    selector: 'scitis-machine-page-header',
    templateUrl: './machine-page-header.component.html',
    styleUrls: ['./machine-page-header.component.scss'],
    standalone: false
})
export class MachinePageHeaderComponent {

  @Input()
  public pageName: string = '';
  @Input()
  public pageType: MenuItemType = MenuItemType.NONE;
  @Input()
  public machineId: string | null = null;
  @Input()
  public pageId: string | null = null;
  @Input()
  public organizationId: string | null = null;
  @Input()
  public machineCategory: string | null = null;

  constructor() {

  }

  public get isTableauPage() {
    return this.pageType === MenuItemType.TABLEAU_PAGE;
  }

  public get isWebGLPage() {
    return this.pageType === MenuItemType.WEBGL_PAGE;
  }


}
